export const getColorLuma = color => {
  const rgb = parseInt(color.substring(1), 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const removeSharp = color => (color.indexOf('#') >= 0 ? color.substring(1, color.length) : color.toString());

const parseColor = color => {
  const stringColor = removeSharp(color);

  return [stringColor.substring(0, 2), stringColor.substring(2, 4), stringColor.substring(4, 6)];
};

const calcVariation = amount => Math.floor((255 * parseInt(amount)) / 100);

const addLight = (color, amount) => {
  const cc = parseInt(color, 16) + amount;
  const c = cc > 255 ? 255 : cc;

  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
};

export const lighten = (color, amount) => {
  const [r, g, b] = parseColor(color);
  const variation = calcVariation(amount);

  return `#${addLight(r, variation)}${addLight(g, variation)}${addLight(b, variation)}`;
};

const subtractLight = (color, amount) => {
  const cc = parseInt(color, 16) - amount;
  const c = cc < 0 ? 0 : cc;

  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
};

export const darken = (color, amount) => {
  const [r, g, b] = parseColor(color);
  const variation = calcVariation(amount);

  return `#${subtractLight(r, variation)}${subtractLight(g, variation)}${subtractLight(b, variation)}`;
};
